export const CharacterType = {
    1: 'PythagorasofSamos',
    2: 'IsaacNewton',
    3: 'SophieGermain',
    4: 'AdaLovelace',
    5: 'ThomasAlvaEdison',
    6: 'NikolaTesla',
    7: 'MarieCurie',
    8: 'AlbertEinstein',
    9: 'RachelLouiseCarson',
    10: 'RosalindFranklin',
};

export const CharacterImageMap = {
    1: require('../assets/characters/PythagorasofSamos.png'),
    2: require('../assets/characters/IsaacNewton.png'),
    3: require('../assets/characters/SophieGermain.png'),
    4: require('../assets/characters/AdaLovelace.png'),
    5: require('../assets/characters/ThomasAlvaEdison.png'),
    6: require('../assets/characters/NikolaTesla.png'),
    7: require('../assets/characters/MarieCurie.png'),
    8: require('../assets/characters/AlbertEinstein.png'),
    9: require('../assets/characters/RachelLouiseCarson.png'),
    10: require('../assets/characters/RosalindFranklin.png'),
};

export const CharacterSmallImageMap = {
    1: require('../assets/characters/smallCharacter/PythagorasofSamos.png'),
    2: require('../assets/characters/smallCharacter/IsaacNewton.png'),
    3: require('../assets/characters/smallCharacter/SophieGermain.png'),
    4: require('../assets/characters/smallCharacter/AdaLovelace.png'),
    5: require('../assets/characters/smallCharacter/ThomasAlvaEdison.png'),
    6: require('../assets/characters/smallCharacter/NikolaTesla.png'),
    7: require('../assets/characters/smallCharacter/MarieCurie.png'),
    8: require('../assets/characters/smallCharacter/AlbertEinstein.png'),
    9: require('../assets/characters/smallCharacter/RachelLouiseCarson.png'),
    10: require('../assets/characters/smallCharacter/RosalindFranklin.png'),
};

export const CharacterSmallGrayImageMap = {
    1: require('../assets/characters/smallGrayCharacter/PythagorasofSamos.png'),
    2: require('../assets/characters/smallGrayCharacter/IsaacNewton.png'),
    3: require('../assets/characters/smallGrayCharacter/SophieGermain.png'),
    4: require('../assets/characters/smallGrayCharacter/AdaLovelace.png'),
    5: require('../assets/characters/smallGrayCharacter/ThomasAlvaEdison.png'),
    6: require('../assets/characters/smallGrayCharacter/NikolaTesla.png'),
    7: require('../assets/characters/smallGrayCharacter/MarieCurie.png'),
    8: require('../assets/characters/smallGrayCharacter/AlbertEinstein.png'),
    9: require('../assets/characters/smallGrayCharacter/RachelLouiseCarson.png'),
    10: require('../assets/characters/smallGrayCharacter/RosalindFranklin.png'),
};

export const CharacterLargeImageMap = {
    1: require('../assets/characters/largeCharacter/PythagorasofSamos.png'),
    2: require('../assets/characters/largeCharacter/IsaacNewton.png'),
    3: require('../assets/characters/largeCharacter/SophieGermain.png'),
    4: require('../assets/characters/largeCharacter/AdaLovelace.png'),
    5: require('../assets/characters/largeCharacter/ThomasAlvaEdison.png'),
    6: require('../assets/characters/largeCharacter/NikolaTesla.png'),
    7: require('../assets/characters/largeCharacter/MarieCurie.png'),
    8: require('../assets/characters/largeCharacter/AlbertEinstein.png'),
    9: require('../assets/characters/largeCharacter/RachelLouiseCarson.png'),
    10: require('../assets/characters/largeCharacter/RosalindFranklin.png'),
};

export const CharacterLargeGrayImageMap = {
    1: require('../assets/characters/largeGrayCharacter/PythagorasofSamos.png'),
    2: require('../assets/characters/largeGrayCharacter/IsaacNewton.png'),
    3: require('../assets/characters/largeGrayCharacter/SophieGermain.png'),
    4: require('../assets/characters/largeGrayCharacter/AdaLovelace.png'),
    5: require('../assets/characters/largeGrayCharacter/ThomasAlvaEdison.png'),
    6: require('../assets/characters/largeGrayCharacter/NikolaTesla.png'),
    7: require('../assets/characters/largeGrayCharacter/MarieCurie.png'),
    8: require('../assets/characters/largeGrayCharacter/AlbertEinstein.png'),
    9: require('../assets/characters/largeGrayCharacter/RachelLouiseCarson.png'),
    10: require('../assets/characters/largeGrayCharacter/RosalindFranklin.png'),
};

// מיפוי טווח תאריכים לכל דמות
export const CharacterDateRangeMap = {
    1: 'character.pythagorasofsamos.dateRange',
    2: '(1642-1727)', // Isaac Newton
    3: '(1776-1831)', // Sophie Germain
    4: '(1815-1852)', // Ada Lovelace
    5: '(1847-1931)', // Thomas Alva Edison
    6: '(1856-1943)', // Nikola Tesla
    7: '(1867-1934)', // Marie Curie
    8: '(1879-1955)', // Albert Einstein
    9: '(1907-1964)', // Rachel Louise Carson
    10: '(1920-1958)', // Rosalind Franklin
};